import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-9999"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15.53 13.135 8.653 1.886a.553.553 0 0 0-.944 0L.832 13.135a.553.553 0 0 0 .472.841h13.754a.553.553 0 0 0 .472-.841zm-7.349-1.686a.629.629 0 1 1 0-1.258.629.629 0 0 1 0 1.258zm.426-1.831h-.853l-.348-2.491a.782.782 0 1 1 1.55 0l-.349 2.491z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }